import { ProductSource } from "@redotech/crdb-enums/product/product-source";
import { Provider } from "@redotech/redo-order-common/provider";

const PRODUCT_SOURCE_PROVIDERS: readonly (readonly [
  ProductSource,
  Provider,
])[] = [
  [ProductSource.Shopify, Provider.SHOPIFY],
  [ProductSource.Bigcommerce, Provider.BIGCOMMERCE],
  [ProductSource.Commentsold, Provider.COMMENTSOLD],
  [ProductSource.CommerceCloud, Provider.COMMERCE_CLOUD],
  [ProductSource.Cin7Omni, Provider.CIN7_OMNI],
  [ProductSource.Cin7Core, Provider.CIN7_CORE],
  [ProductSource.Amazon, Provider.AMAZON],
  [ProductSource.Ebay, Provider.EBAY],
  [ProductSource.Netsuite, Provider.NETSUITE],
  [ProductSource.Walmart, Provider.WALMART],
];

const providerBySource: ReadonlyMap<string, Provider> = new Map(
  PRODUCT_SOURCE_PROVIDERS,
);
const sourceByProvider: ReadonlyMap<Provider, ProductSource> = new Map(
  PRODUCT_SOURCE_PROVIDERS.map(([source, provider]) => [provider, source]),
);

export function productSourceToProvider(
  source: string | null,
): Provider | null {
  return source === null ? null : (providerBySource.get(source) ?? null);
}

export function providerToProductSource(
  provider: Provider | undefined,
): ProductSource | null {
  return provider === undefined
    ? null
    : (sourceByProvider.get(provider) ?? null);
}
